import React, { Component } from 'react';
// import * as $ from 'jquery';
import { translate } from 'react-i18next';

class BenefitSearch extends Component {
  render() {
    const { t } = this.props;
    const cities = this.props.cities
    const categoria = this.props.categorias

    return (
      <div className="panel-benefits">
        <div className="row">
          <div className="col-md-12">
            <form method="post" onSubmit={this.props.handleBenefitsSearch}>
              {/* GETCITIES */}
              <fieldset>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('guest.benefits.city')}
                  </label>
                  <select
                    className="form-control"
                    id="city-select"
                    onChange={this.props.handleCityChange}
                    value={this.props.city}>
                    {cities.map((city, index) =>
                      (<option key={index} className="opcion-select" value={city.id}>{city.name}</option>)
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('guest.benefits.category')}
                  </label>
                  <select
                    className="form-control"
                    id="categoria-select"
                    onChange={this.props.handleCategoriaChange}
                    value={this.props.categoria}>
                    {categoria.map((categoria, index) =>
                      (<option key={index} className="opcion-select" value={categoria.id}>{categoria.name}</option>)
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="event">
                    {t('dashboard.events.label_event')}
                  </label>
                  <input
                    className="form-control"
                    id="event"
                    onChange={this.props.handleBenefitSearch}
                    placeholder={t('dashboard.events.holder_event')}
                    type="text"
                    value={this.props.benefitQuery} />
                </div>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('guest.benefits.lv_benefit')}
                  </label>
                  <select
                    className="form-control"
                    id="city-select"
                    onChange={this.props.handleNivelBenfitChange}
                    value={this.props.nivel_beneficio}>
                    <option className="opcion-select" value="">TODOS LOS PORCENTAJES</option>
                    <option className="opcion-select" value="1">15%</option>
                    <option className="opcion-select" value="2">20%</option>
                    <option className="opcion-select" value="3">30%</option>
                    <option className="opcion-select" value="4">TARIFA_PREFERENCIAL</option>
                  </select>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-search-benefits"
                    disabled={this.props.isSearching}
                    type="submit">
                    {t('dashboard.events.btn_search')}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default translate('common')(BenefitSearch);


// WEBPACK FOOTER //
// ./src/dashboard/benefits/BenefitSeacrh.js